import React from "react";
import styles from "./styles.module.scss";

interface Props {
  label: string;
  data: { title: string; description: string }[];
}

const QuotationResultGrid: React.FC<Props> = ({ label, data }) => {
  return (
    <div className={styles.resultGrid}>
      <div className={styles.label}>{label}</div>

      <div className={styles.list}>
        {data.map((item, index) => (
          <div key={index} className={styles.item}>
            <div className={styles.label}>{item.title}</div>
            <div className={styles.divider} />
            <div className={styles.description}>{item.description}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuotationResultGrid;
